import type { Module } from 'vuex';
import { state } from './state';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import type { ITestSectionScoresReportState } from '@/store/modules/report/test-section-scores-report/types';
import type { RootState } from '@/store/types';

const namespaced: boolean = true;

export const testSectionScoresReportModule: Module<ITestSectionScoresReportState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
